import React from 'react'
import {compose, lifecycle, withState} from 'recompose'
import AutoPartCard from '../finwhale/common/auto-part-card'
import _ from 'lodash'
import {getAttributesOneCard} from "../itemtype"
import getUrl from "../getUrl";
import Loader from "../basic/LoaderCircle"
import getImgUrl from "../getImgUrl";
import CarsSuitableSelection from '../finwhale/common/CarsSuitableSelection'
// import PriceListRequestInline from '../finwhale/common/price-list-request/inline'
import PriceListRequestModal from '../finwhale/common/price-list-request/modal'
import Why from '../finwhale/common/item/why'
import './autoPart.css'
import styled from "styled-components";
import * as media from "../media";
import TranslateText from 'src/text/modal';
import Meta from 'src/basic/Meta';


const P = styled.p`
  font-size: 18px;
  text-align: center;
  margin-bottom: 30px;
  ${media.biggerThan(920)`margin-top: 30px;`}
`

const autoPart = ({
  routeParams,
  card,
  variants,
  type,
  setType,
  loadingCard,
  loadingVariant,
  selectedTab,
  setSelectedTab,
  showPriceListModal,
  setShowPriceListModal,
}) => {
  const goodTitle = !card ? '' : _.get(card, 'attribute_lang.display_name') + ' ' + _.get(card, 'article');

  return (
    <div className='auto-part'>
      <div style={{width: '80%', margin: '0 auto', fontSize: '18px'}}>
        {card &&
          <Meta
            title={`${goodTitle} - автозапчасти Finwhale`}
            description={`${goodTitle} от Finwhale: фото, технические характеристики, комплектация. Где купить ${goodTitle} в Москве и регионах России.`}
          />
        }

        <div style={{height: 30}}/>
        {
          loadingCard ? <Loader/> :
            <AutoPartCard
              img={getImgUrl(`/media/static/product_photos/${_.get(card, 'article', 'null')}.png`)}
              imageList={
                _.compact(_.uniq([
                  ...(_.get(card, 'image_list') || '').split(','),
                ]))
              }
              schemaList={
                _.compact(_.uniq([
                  ...(_.get(card, 'schema_list') || '').split(','),
                ]))
              }
              title={goodTitle}
              code={_.get(card, 'article')}
              data={_.get(card, 'data')}
            >
              <Why
                showPriceListModal={showPriceListModal}
                setShowPriceListModal={setShowPriceListModal}
                card={card}
              />
            </AutoPartCard>
        }

        <P
          style={{
            display: (!variants || !Object.keys(variants).length) && 'none'
          }}
        >
          <span
            style={{
              display: 'inline-block',
              paddingRight: 12,
              fontWeight: 800
            }}
          >
            <TranslateText id={'search__fit_header'}/>
          </span>
        </P>

        {
          loadingVariant
            ? <Loader/>
            : <CarsSuitableSelection variants={variants} selectedTab={selectedTab} setSelectedTab={setSelectedTab}/>
        }
      </div>
      {/* <PriceListRequestInline/> */}
      {
        showPriceListModal &&
        <PriceListRequestModal
          // Если раскомментировать, то брать текст из attribute_lang
          // item_code={_.get(card, 'article')}
          // item_name={_.get(card, 'display_name') + ' ' + _.get(card, 'article')}
          toggle={() => {
            setShowPriceListModal(!showPriceListModal)
          }}
        />
      }
    </div>
  );
}

const enhance = compose(
  withState('selectedTab', 'setSelectedTab', ''),
  withState('showPriceListModal', 'setShowPriceListModal', false),
  lifecycle({
    state: {loadingCard: true, loadingVariant: true},
    componentDidMount() {
      const id = _.get(this.props, 'routeParams.id')
      fetch(getUrl(`/cat/v1/item?id=${id}`))
        .then(data => {
          return data.json()
        }).then(json => {
        let card = _.get(json, 'data.data[0]')
        const data = getAttributesOneCard(card)
        card = {...card, data}
        this.setState({card, loadingCard: false})
        fetch(getUrl(`/cat/v1/searchvariant/?id=${card.id}`)).then(data => {
          return data.json()
        }).then(json => {
          const variants = _.get(json, 'data.data[0].variants')
          try {
            this.props.setSelectedTab(_.get(variants, `[${[Object.keys(variants)[0]]}].name`) || '')
          } catch (e) {
          }
          this.setState({variants, loadingVariant: false})
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }),
  withState('expanded', 'setExpanded', true)
)

export default enhance(autoPart)



// WEBPACK FOOTER //
// ./src/pages/autoPart.js